import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../SettingsHeader";
import {toast} from "react-toastify";
import Accordion from "../../Accordion";
import AdditionalSettings from "./chatWidget/AdditionalSettings";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class ChatWidgetCustomize extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <SettingsHeader title="Chat Widget"/>
                <div className="settings-center-wrap">
                 <Accordion title="additional settings" clicked={true} icon="bx bx-customize" components={AdditionalSettings}/>

                </div>
            </React.Fragment>
        );
    }
}

export default ChatWidgetCustomize;
